<template>
    <div class="dialog">
        <el-dialog :title="this.edit_id == 0 ? '创建拼团活动' : '编辑拼团活动'" :visible.sync="dialogVisible" width="996px" :before-close="handleClose">
            <div class="content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="left" class="demo-ruleForm">
                    <h3 class="sub-title">基础设置</h3>
                    <el-form-item label="活动名称：" prop="name">
                        <el-input v-model="ruleForm.name" :disabled="isDetail" clearable 
                         maxlength="20"
                      show-word-limit
                      placeholder="请输入活动名称，不超过20个字"></el-input>
                    </el-form-item>
                    <el-form-item label="活动时间：" prop="date">
                        <el-date-picker
                            v-model="ruleForm.date"
                            style="width: 100%"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="expireTimeOption"
                            :disabled="isDetail"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="活动类型：" prop="type">
                        <el-radio-group v-model="ruleForm.type" :disabled="isDetail">
                            <el-radio :label="1">普通拼团</el-radio>
                            <!-- <el-radio label="2">阶梯拼团</el-radio> -->
                        </el-radio-group>
                        <p class="tip-text">用户下单开团后，邀请好友一起购买，以优惠价格购买，提升店铺转化</p>
                    </el-form-item>
                    <el-form-item label="参团人数：" prop="number">
                        <el-input v-model="ruleForm.number" :disabled="isDetail" oninput="value=value.replace(/[^\d]/g,'')" clearable placeholder=" 至少2人" style="width: 240px">
                            <template slot="append">人</template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="活动有效期：" prop="task_time">
                        <div>
                       
                            <el-input-number v-model="ruleForm.dd" :disabled="isDetail" clearable style="width: 120px;-webkit-appearance:none;" :min="0" :max="30"> </el-input-number> 日
                            <span v-show="ruleForm.dd != 30">
                                <el-input-number v-model="ruleForm.hh" :disabled="isDetail" clearable :min="0" :max="23" style="width: 120px; margin-left: 16px; -webkit-appearance:none;"> </el-input-number> 时</span
                            >
                            <span v-show="ruleForm.dd != 30">
                                <el-input-number v-model="ruleForm.mm" :disabled="isDetail" clearable :min="0" :max="59" style="width: 120px; margin-left: 16px;-webkit-appearance:none;"> </el-input-number> 分</span
                            >
                        </div>
                        <p class="tip-text">拼团有效期需在15分钟至30天之间 若设置1日，用户开团后，需要在1日内成团，超时则失败</p>
                    </el-form-item>

                    <el-form-item label="优惠叠加：" prop="coupon_type">
                        <el-radio-group v-model="ruleForm.coupon_type" :disabled="isDetail">
                            <el-radio :label="1">不叠加其他营销活动或优惠券</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <h3 class="sub-title">更多设置</h3>
                    <el-form-item label="在线凑团：" prop="on_line_group">
                        <el-radio-group v-model="ruleForm.on_line_group" :disabled="isDetail">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="2">关闭</el-radio>
                        </el-radio-group>
                        <p class="tip-text">开启后，商品详情会显示未成团的团，用户可任意选一个参团，提升成团率</p>
                    </el-form-item>
                    <el-form-item label="模拟成团：" prop="analog_group">
                        <el-radio-group v-model="ruleForm.analog_group" :disabled="isDetail">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="2">关闭</el-radio>
                        </el-radio-group>
                        <p class="tip-text">开启后，当在拼团有效期内或拼团活动结束前，人数未满的团，系统将会模拟“匿名”买家凑满人数，使其成团</p>
                        <p class="warn-text">注意：模拟成团的团长也可以享受团长价格，请谨慎设置</p>
                        <el-input
                            v-if="ruleForm.analog_group == 1"
                            oninput="value=value.replace(/[^\d]/g,'')"
                            v-model="ruleForm.analog_group_number"
                            clearable
                            style="width: 320px; margin-top: 16px"
                            placeholder="模拟参团人数需小于参团人数"
                            :disabled="isDetail"
                        >
                            <template slot="append">人</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="团长价：" prop="is_open_leader_price">
                        <el-radio-group v-model="ruleForm.is_open_leader_price" :disabled="isDetail">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="2">关闭</el-radio>
                        </el-radio-group>
                        <p class="tip-text">开启后，团长（开团人）将享受更优惠价格，有助于提高开团率和成团率</p>
                        <p class="warn-text">注请注意：模拟成团的团长也能享受团长优惠，请谨慎设置，避免资金损失</p>
                    </el-form-item>
                    <el-form-item label="活动预热：" prop="activity_prepare">
                        <el-radio-group v-model="ruleForm.activity_prepare" :disabled="isDetail">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="2">关闭</el-radio>
                        </el-radio-group>
                        <p class="tip-text">开启后，会即时在商品详情页展示尚未开始的拼团活动预告；活动开始后，用户才能使用拼团价格</p>
                    </el-form-item>
                    <!-- <el-form-item label="活动商品：">
                        <el-button type="primary" @click="showGoods" size="small" style="margin-right: 12px">添加</el-button>
                        <span v-if="count">已添加 {{ count }} 个商品</span>
                    </el-form-item> -->
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" 
                 v-if="!isDetail"
                @click="submit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
            dialogVisible: false,
            ruleForm: {
                name: "",
                date: null,
                number: "",
                dd: "",
                hh: "",
                mm: "",
                on_line_group: 1,
                is_open_leader_price: 1,
                analog_group: 1,
                activity_prepare: 1,
                analog_group_number: "",
                coupon_type: 1,
                type: 1,
            },
            rules: {
                name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
                date: [{ required: true, message: "请选择活动时间", trigger: "change" }],
                number: [{ required: true, message: "请输入人数", trigger: "blur" }],
                on_line_group: [{ required: true, message: "请选择是否开启在线凑团", trigger: "change" }],
                analog_group: [{ required: true, message: "请选择是否开启模拟组团", trigger: "change" }],
                is_open_leader_price: [{ required: true, message: "请选择是否开启团长价", trigger: "change" }],
                activity_prepare: [{ required: true, message: "请选择是否开启活动预热", trigger: "change" }],
            },
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    props: {
        count: {
            type: Number,
            default: 0,
        },
        edit_id: {
            type: Number,
            default: 0,
        },
        isDetail: {
            type: Boolean,
            default: false,
        },
    },
    created(){
console.log(this.ruleForm.activity_prepare)
    },
    methods: {
        ...mapActions({
          /*    createActivityLink: "activity/createActivityLink",
            editLink: "activity/editLink",
            getActivityDetailLinknk: "activity/getActivityDetailLink", */
            createTeam: "activity/createActivityLink",
            editTeam: "activity/editLink",
            getActivityDetailTeam: "activity/getActivityDetailLink",
        }),
        getDetail(id) {
            this.loading = true;
            let params = {
                token: this.getToken,
                id: id,
            };
            this.getActivityDetailTeam(params).then(({ data }) => {
                if (data.code == 1) {
                    let { name, start_time, end_time, number, task_time, on_line_group, is_open_leader_price, analog_group, activity_prepare,analog_group_number } = data.data;
                    let dd, hh, mm;
                    dd = parseInt(task_time / 24 / 60 / 60);
                    hh = parseInt((task_time - dd * 24 * 60 * 60) / 60 / 60);
                    mm = task_time<=3540?parseInt(task_time/60):parseInt((task_time - dd * 24 * 60 * 60 - hh * 60 * 60)/60);
                    this.ruleForm = {
                        name: name,
                        date: [start_time, end_time],
                        number: number,
                        dd: dd,
                        hh: hh,
                        mm: mm,
                        on_line_group: on_line_group,
                        is_open_leader_price: is_open_leader_price,
                        analog_group: analog_group,
                        activity_prepare: activity_prepare,
                        analog_group_number: analog_group_number,
                        coupon_type: 1,
                         type: 1
                    };
                } else {
                    this.$message.error(data.msg);
                }
                this.loading = false;
            });
        },
        submit() {
        
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let { name, date, number, dd, hh, mm, on_line_group, is_open_leader_price, analog_group, activity_prepare, type, analog_group_number } = this.ruleForm;
                    if (dd == 30) {
                        hh = 0;
                        mm = 0;
                    }
                    let params = {
                        token: this.getToken,
                        name: name,
                        start_time: date ? date[0] : null,
                        end_time: date ? date[1] : null,
                        type:2, 
                        number: number,//拼团活动-人数
                        task_time: dd * 24 * 60 * 60 + hh * 60 * 60 + mm * 60,
                        on_line_group: on_line_group,
                        is_open_leader_price: is_open_leader_price,
                        analog_group: analog_group,
                        activity_prepare: activity_prepare,
                        team_type:type,
                    };

     console.log(params,'params----')
                    if (analog_group == 1) {
                        params.analog_group_number = analog_group_number;
                        if (!analog_group_number) {
                            return this.$message.warning("请输入模拟组人数！");
                        }
                    }
                    let url;
                    if (this.edit_id == 0) {
                        url = this.createTeam;
                    } else {
                        url = this.editTeam;
                        params.id = this.edit_id;
                    }
                    url(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success(`${this.edit_id == 0 ? "添加成功" : "修改成功"}！`);
                            this.handleClose();
                            this.$emit("initList");
                        } else {
                            this.$message.error(data.msg);
                        }
                        /* this.$emit("initList"); */
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.ruleForm = {
                name: "",
                date: null,
                number: "",
                dd: "",
                hh: "",
                mm: "",
                on_line_group: 1,
                is_open_leader_price: 1,
                analog_group: 1,
                activity_prepare: 1,
                analog_group_number: "",
                coupon_type: 1,
                type: 1,
            };
            this.$emit("dataInit");
        },
        // 显示商品
        showGoods() {
            if (!this.ruleForm.date) return this.$message.warning("请先选择活动起止时间！");
            this.$emit("showGoods", this.ruleForm.date, this.ruleForm.is_open_leader_price);
        },
        // 显示商品列表
        showSelDetail() {
            this.$emit("showSelDetail");
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #dcdfe6;
}
::v-deep .el-dialog__body {
    padding: 30px 80px;
    height: 600px;
    overflow-y: auto;
    &::-webkit-scrollbar-track-piece {
        background: #d3dce6;
    }

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 20px;
    }
}
.df {
    ::v-deep .el-form-item__content {
        display: flex;
    }
}
.el-radio {
    height: 36px;
    line-height: 36px;
}
.el-radio-group {
    position: relative;
    width: 100%;
    .el-input {
        position: absolute;
        right: 160px;
        bottom: 0;
    }
    .tip {
        position: absolute;
        right: 160px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        color: #999;
    }
}
::v-deep .el-form-item__label {
    &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
    }
}
.df {
    .el-radio-group {
        display: flex;
        flex-direction: column;
    }
}
.tip-text {
    line-height: 24px;
    font-size: 12px;
    color: #999;
    margin-top: 16px;
}
.warn-text {
    line-height: 24px;
    font-size: 12px;
    color: red;
}
.sub-title {
    margin: 60px 0 40px;
    font-size: 18px;
    color: #333;
    margin-right: 10px;
    padding-left: 12px;
    position: relative;
      &:first-child {
        margin-top: 0;
    }
    &::before {
        content: "";
        width: 3px;
        height: 18px;
        background: #2448ff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}

::v-deep .el-range-editor.is-disabled input,
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #666;
}
</style>